<template>
  <!-- ログアウト、メニューあり版 -->
  <v-app id="inspire">

   <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      right
      mobile-break-point=600
    >
      <MpMenu />
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-right
      flat
      dark
      color="brack"
    >
      <router-link to="/" style="text-decoration: none; color: #FFFFFF;" class="d-block d-md-block">
        <v-img v-if="!$vuetify.breakpoint.xs" src="../assets/logo.png" max-width="360" max-height="47" class="mr-3"></v-img>
        <v-img v-if="$vuetify.breakpoint.xs" src="../assets/logo.png" max-width="240" max-height="26" class="mr-3"></v-img>
      </router-link>
      <v-spacer></v-spacer>
      <MpLang />
      <MpLogout class="ml-1"/>
      <v-app-bar-nav-icon v-if="$vuetify.breakpoint.xs" @click.stop="drawer = !drawer" />
    </v-app-bar>

    <v-content>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-content>

    <MpFooter />
  </v-app>
</template>

<script>
import MpMenu from '@/components/parts/MpMenu.vue'
import MpFooter from '@/components/parts/MpFooter.vue'
import MpLang from '@/components/parts/MpLang.vue'
import MpLogout from '@/components/parts/MpLogout.vue'

export default {
  components: {
    MpMenu,
    MpFooter,
    MpLang,
    MpLogout
  },
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  }),
  created () {
    this.$vuetify.theme.dark = false
  }
}
</script>

<style>
div.v-toolbar__title {
  font-size: 2.0rem;
}
</style>
